var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{staticStyle:{"width":"100vw"},attrs:{"src":require("../../assets/img/bg-learn.png"),"alt":""}})])
}]

export { render, staticRenderFns }